import { render } from "./Applications.vue?vue&type=template&id=bf6c3462&scoped=true&ts=true"
import script from "./Applications.vue?vue&type=script&lang=ts"
export * from "./Applications.vue?vue&type=script&lang=ts"

import "./Applications.vue?vue&type=style&index=0&id=bf6c3462&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf6c3462"]])

export default __exports__